import React from "react";
import { Typography, Link } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
    boldText: {
        fontWeight: 600,
        color: "#1DB584"
    },
    roleItem: {
        marginBottom: 8,
        paddingLeft: 16
    },
    noteText: {
        fontStyle: "italic",
        color: "#666",
        marginTop: 8
    },
    linkText: {
        color: "#1DB584",
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    }
});

export default function FormattedText({
    text,
    details,
    note,
    link,
    className
}) {
    const classes = useStyles();

    const formatText = text => {
        if (!text) return null;

        // Handle bold text with **text**
        const parts = text.split(/(\*\*.*?\*\*)/g);
        return parts.map((part, index) => {
            if (part.startsWith("**") && part.endsWith("**")) {
                const boldText = part.slice(2, -2);
                return (
                    <span key={index} className={classes.boldText}>
                        {boldText}
                    </span>
                );
            }
            return part;
        });
    };

    return (
        <div className={className}>
            <Typography
                variant="body1"
                style={{ lineHeight: 1.6, marginBottom: 8 }}
            >
                {formatText(text)}
            </Typography>

            {details && (
                <div style={{ marginTop: 12 }}>
                    {details.map((item, index) => (
                        <div key={index} className={classes.roleItem}>
                            <Typography variant="body2">
                                <span className={classes.boldText}>
                                    {item.role}:
                                </span>{" "}
                                {item.description}
                            </Typography>
                        </div>
                    ))}
                </div>
            )}

            {note && (
                <Typography variant="body2" className={classes.noteText}>
                    <strong>Note:</strong> {note}
                </Typography>
            )}

            {link && (
                <div style={{ marginTop: 12 }}>
                    <Link
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={classes.linkText}
                    >
                        {link.text}
                    </Link>
                </div>
            )}
        </div>
    );
}
